import createReactComponent from '../createReactComponent';
export default createReactComponent('trending-up', 'TrendingUp', [["path",{"d":"m20 7-5.846 5.938c-1.964 1.983-4.106-2.148-6.153-.001L4 17m9-10h7v7","key":"svg-0"}]]);